import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export default styled.section`
  background-color: #ffffff;
  min-height: 100vh;

  @media (min-width: ${getBreakpoint('xl')}px) {
    background-color: #f5f5fa;
  }
`
